import React from 'react';
//import {authRoles} from '../../auth';

export const CertificadosConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['funcionario'],
    routes  : [
        {
            path     : '/certificados',
            component: React.lazy(() => import('./Certificados'))
        }
    ]
};